export var NAV_BAR_ACTIONS;

(function (NAV_BAR_ACTIONS) {
  NAV_BAR_ACTIONS[NAV_BAR_ACTIONS["RESET_STATE"] = 0] = "RESET_STATE";
  NAV_BAR_ACTIONS[NAV_BAR_ACTIONS["SET_ACTIVE_ITEM"] = 1] = "SET_ACTIVE_ITEM";
})(NAV_BAR_ACTIONS || (NAV_BAR_ACTIONS = {}));

export var NAV_BAR_INITIAL_STATE = {
  activeItem: '',
  shouldAnimate: true
};
export var navBarReducer = function navBarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NAV_BAR_INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case NAV_BAR_ACTIONS.SET_ACTIVE_ITEM:
      {
        return {
          activeItem: action.selectedItem,
          shouldAnimate: state.activeItem === ''
        };
      }

    case NAV_BAR_ACTIONS.RESET_STATE:
      {
        return NAV_BAR_INITIAL_STATE;
      }
  }

  throw Error("Unknown action: ".concat(action.type));
};